import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CampaignReportsMfeRoutingModule } from './campaign-reports-mfe-routing.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    CampaignReportsMfeRoutingModule
  ]
})
export class CampaignReportsMfeModule { }
